import React from "react";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Box from "@mui/material/Box";
import Button from "reactstrap/lib/Button";
import getStyle, { BaseField as Base, fontConfig as fontBase, getOptions } from "./utils";
import Font from "./Font";

export default function FrameFont(props){
	let { values, setFieldValue, setScrollTop, zoomin } = props;
	
	let frame = values?.frame;
	const currentStyle = getStyle(frame?.style);
	const disableText = !!currentStyle?.disableText;
	const twoText     = currentStyle?.twoText;
	const maxFontSize = currentStyle?.maxFontSize;
	const [activeTab, tab] = React.useState(0);
	
	function tabToggle(value){
		setScrollTop(true);
		tab(value);
	}
	
	function a11yProps(index){
		return  ({
			color: activeTab === index ? 'light':'default',
			value: `${index}`,
			style: { 'minWidth': '150px', lineHeight: '18px' },
			onClick: () => tabToggle(index)
		})
	}
	
	
	return <>
		{(!!(twoText && !disableText)) && <>
			<div className={'d-flex justify-content-center'}>
				<div className={'px-0'}>
					<Box sx={{
						backgroundColor: `rgb(118, 118, 128, 0.12)`,
						padding: '2px',
						marginBottom: '15px',
						maxWidth: '360px',
						width: '100%',
						borderRadius: '5px'
					}}
					>
						<Row none>
							<Col xs={6}><Button {...a11yProps(0)}><>{'Text 1'.t()}</></Button></Col>
							<Col xs={6}><Button {...a11yProps(1)}><>{'Text 2'.t()}</></Button></Col>
						</Row>
					</Box>
				</div>
			</div>
		</>}
		{(!disableText && activeTab === 0) && <Font {...props} {...{ maxFontSize, values: frame?.text_1, name: 'frame.text_1'}} />}
		{(!!twoText && activeTab === 1) && <Font {...props}  {...{ maxFontSize, values: frame?.text_2, name: 'frame.text_2'}} />}
	</>
}